import Cookies from 'js-cookie';

import { cookieKeyUser } from './const';

const setCookie = (data) => {
    Cookies.set(cookieKeyUser, JSON.stringify(data), { path: '/', domain: process.env.REACT_APP_DOMAIN_WEB });
};

const getCookie = () => {
    return Cookies.get(cookieKeyUser, { path: '/', domain: process.env.REACT_APP_DOMAIN_WEB });
};

const removeCookie = () => {
    Cookies.remove(cookieKeyUser, { path: '/', domain: process.env.REACT_APP_DOMAIN_WEB });
};

const handleLogoutCookie = () => {
    removeCookie();
};

const handleLoginCookie = (data) => {
    setCookie(data);
};

export { handleLogoutCookie, handleLoginCookie, getCookie };
